module.exports = __webpack_public_path__ + "static/media/ma_payments.bde4e1e3.png";